import { Component, JSXElement, onCleanup, onMount } from "solid-js"

type Props = {
    selector: string;
    children: JSXElement;
}
export const ScrollToTarget : Component<Props> = (props) => {
    let links: NodeListOf<HTMLElement>;
    const getLinks = () => document.querySelectorAll(props.selector) as NodeListOf<HTMLElement>;
    const scrollToTarget = (e: MouseEvent) => {
        if (!e) return;
        const aName = ((e.target as HTMLElement).getAttribute("data-target") as string)?.replace("#", "");
        const parent = document.querySelector(`a[name='${aName}']`)?.parentElement;
        if (!parent) return;
        let target = parent;        
        const destination = target || parent;
        destination.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };
    const setup = () => { links = getLinks(); links.forEach(el => el.addEventListener('click', scrollToTarget)) };
    onMount(() => setup());
    onCleanup(() => links.forEach(el => el.removeEventListener('click', scrollToTarget)));
    return (
        <>
            {props.children}
        </>
    )
}